"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.effectToJSON = exports.effectFromJSON = exports.Effect = exports.protobufPackage = void 0;
exports.protobufPackage = "cerbos.effect.v1";
var Effect;
(function (Effect) {
    Effect[Effect["EFFECT_UNSPECIFIED"] = 0] = "EFFECT_UNSPECIFIED";
    Effect[Effect["EFFECT_ALLOW"] = 1] = "EFFECT_ALLOW";
    Effect[Effect["EFFECT_DENY"] = 2] = "EFFECT_DENY";
    Effect[Effect["EFFECT_NO_MATCH"] = 3] = "EFFECT_NO_MATCH";
})(Effect || (exports.Effect = Effect = {}));
function effectFromJSON(object) {
    switch (object) {
        case 0:
        case "EFFECT_UNSPECIFIED":
            return Effect.EFFECT_UNSPECIFIED;
        case 1:
        case "EFFECT_ALLOW":
            return Effect.EFFECT_ALLOW;
        case 2:
        case "EFFECT_DENY":
            return Effect.EFFECT_DENY;
        case 3:
        case "EFFECT_NO_MATCH":
            return Effect.EFFECT_NO_MATCH;
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Effect");
    }
}
exports.effectFromJSON = effectFromJSON;
function effectToJSON(object) {
    switch (object) {
        case Effect.EFFECT_UNSPECIFIED:
            return "EFFECT_UNSPECIFIED";
        case Effect.EFFECT_ALLOW:
            return "EFFECT_ALLOW";
        case Effect.EFFECT_DENY:
            return "EFFECT_DENY";
        case Effect.EFFECT_NO_MATCH:
            return "EFFECT_NO_MATCH";
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Effect");
    }
}
exports.effectToJSON = effectToJSON;
const tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
//# sourceMappingURL=effect.js.map